var _this = this,
  _jsxFileName = "/builds/EgNbCExi/0/ramsey-solutions/ramsey-plus/survey-ui/src/components/NPSGroup/NPSGroup.js";
import React from "react";
import { Field } from "formik";

/**
 * accessibility attribute for min and max
 * @param  {number} index index
 * @returns {string|null} element ID
 */
var getAriaAttribute = function getAriaAttribute(index) {
  var elementId = null;
  if (index === 0) {
    elementId = "leftLabel";
  } else if (index === 10) {
    elementId = "rightLabel";
  }
  return elementId;
};

/**
 * Sets the color based on the range
 * @param {string} rangeValue range value
 * @returns {string} component's variant class
 */
var colorVariant = function colorVariant(rangeValue) {
  var npsNumber = parseInt(rangeValue, 10);
  var NPS_RATING_LOW = 6;
  var NPS_RATING_MID = 8;
  if (npsNumber <= NPS_RATING_LOW) {
    return "survey-NPSGroup-input--red";
  } else if (npsNumber > NPS_RATING_LOW && npsNumber <= NPS_RATING_MID) {
    return "survey-NPSGroup-input--yellow";
  }
  return "survey-NPSGroup-input--green";
};
var NPSGroup = function NPSGroup(_ref) {
  var question = _ref.question;
  return /*#__PURE__*/React.createElement("div", {
    className: "survey-NPSGroup",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "survey-NPSGroup-boundary",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("span", {
    id: "leftLabel",
    className: "survey-NPSGroup-boundaryLabel",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }, "0 - ", question.labels.left), /*#__PURE__*/React.createElement("span", {
    id: "rightLabel",
    className: "survey-NPSGroup-boundaryLabel",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 7
    }
  }, "10 - ", question.labels.right)), /*#__PURE__*/React.createElement("div", {
    className: "survey-NPSGroup-inputGroup",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, question.options.map(function (radioOption, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "survey-NPSGroup-input ".concat(colorVariant(radioOption.label)),
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 52,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Field, {
      id: radioOption.id,
      "aria-describedby": getAriaAttribute(index),
      name: question.alias,
      required: true,
      type: "radio",
      value: radioOption.id,
      "data-testid": "NPS",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: radioOption.id,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 11
      }
    }, radioOption.label));
  })));
};
export { NPSGroup as default };